export function getMissingMandatoryRoles(activeAttributes = [], { caseTypeId, legalPositionId, caseParties = [] } = {}) {
  if (caseTypeId == null || legalPositionId == null || activeAttributes.length == 0) {
    return [];
  }

  const mandatoryRoleIds = new Set();
  activeAttributes.forEach((attr) => {
    if (!attr.isOptional && attr.partyRoleId != null) {
      mandatoryRoleIds.add(attr.partyRoleId);
    }
  });
  if (mandatoryRoleIds.size == 0) return [];

  const casePartyRoles = new Set();
  caseParties.forEach((cp) => {
    if (cp.subPartyRoleId != null) {
      casePartyRoles.add(cp.subPartyRoleId);
    }
  });

  const missing = [];
  mandatoryRoleIds.forEach((rid) => {
    if (!casePartyRoles.has(rid)) {
      missing.push(rid);
    }
  });

  return missing;
}
